module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/coupon-illust-0b6e25ead51d9342e85016c0469f5c40.svg";